import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const ON_POLICY_DATA_PULL_COMPLETED = gql`
  fragment OnPolicyDataPullCompletedParts on OnPolicyDataPullCompleted {
    policyId
  }
`;
